// extracted by mini-css-extract-plugin
export default {"searchControl":"searchControl---mRWGQ","marginBottom0":"marginBottom0---N7Z1j","marginTop0":"marginTop0---o8Wjl"};